<template>
    <v-select
        v-model="localValue"
        :label="label || undefined"
        :placeholder="placeholder"
        :items="items"
        :item-title="itemTitle"
        :item-value="itemValue"
        :chips="chips"
        :closable-chips="closableChips"
        :multiple="multiple"
        :rules="rules"
        :return-object="returnObject"
        :hide-details="hideDetails === true || hideDetails === '' ? true : (hideDetails || false)"
        density="compact"
        :variant="variant || 'outlined'"
    ></v-select>
</template>

<script>

export default {

    props: {
        chips: Boolean,
        closableChips: Boolean,
        hideDetails: [Boolean, String],
        items: Array,
        itemTitle: String,
        itemValue: String,
        label: String,
        multiple: Boolean,
        placeholder: String,
        returnObject: Boolean,
        rules: Array,
        value: Object,
        variant: String,
    },

    data() {
        return {
            localValue: this.value
        };
    },
}

</script>
